import { Alert, Backdrop, Box, Button, Card, CircularProgress, Container, Link, TextField, Typography } from "@mui/material";
import { Warning } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Helper } from "../services/Helper";
import { ValidationCode } from "../enums/enums";
import { Validation } from "../models/Validation";
import { InquiryService } from "../services/InquiryService";

export default function ContactUs() {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const [name, setName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isValidating, setIsValidating] = useState(false);
    const [validation, setValidation] = useState(new Validation());
    const [message, setMessage] = useState(params.get("inquiry") || "");
    const inquiryService = new InquiryService();
    const navigate = useNavigate();
    function onSubmit() {
        setIsValidating(true);
        if (!Helper.HasValue(phoneNumber)) {
            setValidation({ Code: ValidationCode.ERROR, Message: "Enter your phone number." });
            setIsValidating(false);
        } else if (!Helper.IsValidPhoneNumber(phoneNumber)) {
            setValidation({ Code: ValidationCode.ERROR, Message: "Phone number should be 11 digits and start with 09." });
            setIsValidating(false);
        } else if (!Helper.HasValue(name)) {
            setValidation({ Code: ValidationCode.ERROR, Message: "Enter your name." });
            setIsValidating(false);
        } else if (!Helper.HasValue(message)) {
            setValidation({ Code: ValidationCode.ERROR, Message: "Enter your concern." });
            setIsValidating(false);
        } else {
            inquiryService.Create({ InquiryID: 0, Name: name, PhoneNumber: phoneNumber, Message: message }).then(response => {
                if (response.Data != undefined && response.IsSuccessful) {
                    setPhoneNumber("");
                    setName("");
                    setMessage("");
                    setValidation({ Code: ValidationCode.VALID, Message: "Your concern/inquiry has been submitted. We will get back to you as soon as possible." });
                } else {
                    setValidation({ Code: ValidationCode.ERROR, Message: response.Message })
                }
            }).catch(error => {
                setIsValidating(false);
                setValidation({ Code: ValidationCode.ERROR ? ValidationCode.VALID : ValidationCode.ERROR, Message: error })
            }).finally(() => {
                setIsValidating(false);
            });
        }
    }



    return (
        <Container>
            <Backdrop open={isValidating} sx={{ zIndex: 100000 }}>
                <CircularProgress color="error"></CircularProgress>
            </Backdrop>
            <Card sx={{ marginTop: 15, background: "#FEF9F8", padding: 4, marginX: "auto", maxWidth: 400, boxShadow: { xs: 'none', md: 'var(--Paper-shadow)' } }}>
                <Typography variant="h4" sx={{ marginBottom: 4 }}>
                    Contact us
                </Typography>
                <Typography variant="subtitle2" sx={{ marginBottom: 4 }}>
                    Please fill out the form below and we will get back to you as soon as possible.
                </Typography>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="Phone number" placeholder="This number will receive our call or reply." variant="outlined" fullWidth={true} value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="Name" variant="outlined" placeholder="Your full name" fullWidth={true} value={name} onChange={(e) => setName(e.target.value)}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField multiline rows={4} placeholder="Please describe your concern or inquiry." label="Concern / Inquiry" variant="outlined" fullWidth={true} value={message} onChange={(e) => setMessage(e.target.value)}></TextField>
                </Box>
                {/* <Alert icon={<Warning></Warning>} severity="warning" sx={{ marginBottom: 4 }}>All fields are required.</Alert> */}
                {
                    validation.Code == ValidationCode.ERROR
                    &&
                    <Alert severity="error" sx={{ marginBottom: 4 }}>
                        {validation.Message}
                    </Alert>
                }
                {
                    validation.Code == ValidationCode.VALID
                    &&
                    <Alert severity="success" sx={{ marginBottom: 4 }}>
                        {validation.Message}
                    </Alert>
                }
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Link href="/sign-in" variant="body2" color="textSecondary" sx={{ textDecoration: "none" }} onClick={(e) => { navigate(-1) }}>
                        Cancel
                    </Link>
                    <Button variant="contained" color="error" onClick={onSubmit}>
                        Submit
                    </Button>
                </Box>
            </Card>
        </Container>
    );
}